<template>
	<div class="row">
		<div class="col-md-12" v-if="status == 'selection'">
			<div class="row">
				<div class="col-md-6">
					<span><b>Step 1-4:selection</b></span>
				</div>
			</div>
			<div class="col-md-6">
				<div class="row">
	                <div class="col-md-3">
	                    <label class="col-form-label">Sales Order Number</label>
	                </div>
	                <div class="col-md-8">
	                    <multiselect placeholder="Select Sales order number" label="sales_order_number" v-model="sales_order" :options="sales_orders" :searchable="true" :allow-empty="true"></multiselect>
	                </div>
	            </div>
			</div>
			<div class="col-md-6 mb-1">
				<div class="row">
	                <div class="col-md-2">
	                    <label class="col-form-label">ETD Vendor</label>
	                </div>
	                <div class="col-md-4">
	                    <el-date-picker
                        v-model="unformat_etd_date_range"
                        type="daterange"
                        placeholder="Pick a range">
                        </el-date-picker>
	                </div>
	            </div>
			</div>
			<div class="col-md-12 mb-1">
				<div class="row">
					<div class="col-md-6">
						<div class="row">
			                <div class="col-md-3"></div>
			                <div class="col-md-4">
			                    <multiselect v-model="vendor_filters" :close-on-select="false" :show-labels="false" :multiple="true" placeholder="Select Vendors" label="name" track-by="name" :options="vendors" :searchable="true" :allow-empty="true"></multiselect>
			                </div>
			                <div class="col-md-4">
			                    <multiselect v-model="item_manufacturer_filters" :close-on-select="false" :show-labels="false" :multiple="true" placeholder="Select Manufacturers" label="name" track-by="name" :options="item_manufacturers" :searchable="true" :allow-empty="true"></multiselect>
			                </div>
			            </div>
					</div>
					<div class="col-md-6">
						<div class="row">
			                <div class="col-md-2">
			                    <label class="col-form-label">Shipping Method</label>
			                </div>
			                <div class="col-md-4">
			                    <multiselect v-model="shipping_method" :close-on-select="false" :show-labels="false" :multiple="true"  placeholder="Select Shipping Method" label="name" track-by="id" :options="shipping_methods" :searchable="true" :allow-empty="true"></multiselect>
			                </div>
			            </div>
					</div>
				</div>
			</div>
			<div class="col-md-12 mb-1">
				<div class="row">
					<div class="col-md-6">
						<div class="row">
							<div class="col-md-3">
								<label class="col-form-label"></label>
							</div>
							<div class="col-md-8">
								<input @keyup="getSalesOrderItems(1)" v-model="search" type="text" name="" class="form-control pull-left" placeholder="Part Number"> &nbsp;
							</div>
						</div>
					</div>
					<div class="col-md-6 mb-1">
						<div class="row">
			                <div class="col-md-2">
			                    <label class="col-form-label">Delivery Code</label>
			                </div>
			                <div class="col-md-4">
			                    <multiselect v-model="delivery_code" :close-on-select="false" :show-labels="false" :multiple="true"  placeholder="Select Delivery Code" label="code" track-by="id" :options="delivery_codes" :searchable="true" :allow-empty="true"></multiselect>
			                </div>
			            </div>
					</div>
				</div>
			</div>
			<div class="col-md-6">
				<div style="height:40px"></div>
			</div>

			<div class="row">
				<div class="col-md-12">
					<div class="row">
						<!-- <div class="col-md-12">
							<input @keyup="getSalesOrderItems(1)" v-model="search" type="text" name="" class="form-control pull-left" style="width:200px;" placeholder="Search Item"> &nbsp;
	                        <button @click="getSalesOrderItems(1)" class="btn btn-warning"><i class="fa fa-refresh"></i></button>
						</div> -->
						<div class="col-md-12">
							<br>
							<el-table
								:data="sales_order_items"
								border
								v-loading.body="sales_order_items_all"
								:row-class-name="statusClass"
								@sort-change="sortTable"
								style="width: 100%;">
								<el-table-column
									prop="sales_order.sales_order_number"
									:show-overflow-tooltip="true"
									width="160"
	                                label="Sales Order No">
								</el-table-column>
								<el-table-column
									prop="sales_order.client_delivery_address.code"
									:show-overflow-tooltip="true"
									width="160"
	                                label="Delivery Code">
								</el-table-column>
								<el-table-column
									prop="quotation.item.manufacturer"
									:show-overflow-tooltip="true"
									width="250"
	                                label="Manufacturer">
								</el-table-column>
								<el-table-column
									prop="quotation.vendor.name"
									:show-overflow-tooltip="true"
									width="250"
	                                label="Vendor">
								</el-table-column>
								<el-table-column
	                                prop="quotation.item.part_number"
	                                :show-overflow-tooltip="true"
	                                label="Part Number"
	                                width="160">
	                            </el-table-column>
	                            <el-table-column
	                                prop="quantity"
	                                width="150"
	                                label="QTY">
	                            </el-table-column>
	                            <el-table-column
		                            label="ETD Vendor"
		                            :show-overflow-tooltip="true"
		                            class-name="estimated-td-vendor"
		                            width="200"
		                            :sortable="'custom'"
                                prop="estimated_td_vendor"
		                            >
		                             <template scope="scope">
		                                <span>{{scope.row.estimated_td_vendor != null && scope.row.estimated_td_vendor != '' ? scope.row.estimated_td_vendor : 'Waiting for PO'}}</span>
		                            </template>
	                            </el-table-column>
	                            <el-table-column
		                            label="ETA HK"
		                            :show-overflow-tooltip="true"
		                            class-name="estimated-td-hk"
		                            width="200">
		                            <template scope="scope">
		                                <span v-if="!scope.row.direct_shipment">
		                                    {{scope.row.estimated_arrival_date_hk != null && scope.row.estimated_arrival_date_hk != ''? scope.row.estimated_arrival_date_hk : 'Waiting for PO'}}
		                                </span>
		                                <span v-else>
		                                	Direct Shipment
		                                </span>
		                            </template>
		                        </el-table-column>
		                        <el-table-column
                                :class-name="'col estimated-td-hk'"
                                width="200" 
                                label="Confirmed TD HK"
                                :sortable="'custom'"
                                prop="estimated_td_date">
                                <template scope="scope">
									<div v-if="scope.row.direct_shipment">Direct Shipment</div>
									<div v-else>
										<div v-if="!scope.row.estimated_td_date">
											<span v-if="!scope.row.direct_shipment">Pending</span>
										</div>
										<div v-else>
											<span>{{scope.row.estimated_td_date}}</span>
										</div>
									</div>
                                </template>
                              </el-table-column>
		                        <el-table-column
	                                prop="shipping_method.name"
	                                :show-overflow-tooltip="true"
	                                width="200"
	                                label="Shipping Method">
	                            </el-table-column>
	                          <el-table-column
                              :class-name="'col estimated-weight'"
                              width="200" 
                              label="Estimated weight, kg">
                              <template scope="scope">
                              	<span>{{ (scope.row.quotation.item.weight_grams > 0 ? ((scope.row.quotation.item.weight_grams * scope.row.quantity) / 1000) : ((scope.row.quotation.item.category.average_weight_grams * scope.row.quantity) / 1000)) | currency('', 2, {thousandsSeparator: ','})}}</span>
                              </template>
                            </el-table-column>
	                            <el-table-column
	                                class-name="text-center"
	                                label="Operations"
	                                width="150">
	                                <template scope="scope">
	                                    <button @click="addItem(scope.row)" :disabled="isAdded(scope.row)" class="btn btn-primary btn-xtra-small">
	                                        <i class="fa fa-plus"></i>
	                                    </button>
	                                </template>
	                            </el-table-column>
							</el-table>
							<el-pagination
	                            :total="pagination.total"
	                            layout="total, prev, pager, next, sizes"
	                            :current-page="pagination.current_page"
	                            @current-change="fetchPaginate"
	                            :page-size="limit"
	                            @size-change="handleSizeChange"
	                            :page-sizes="[5, 10, 15, 20, 25, 30, 50]"
	                            >
	                        </el-pagination>
						</div>
						<div class="col-md-12">
							<br> Selected Items <br>
							<el-table
								:data="items"
								border
								:row-class-name="statusClass"
								style="width: 100%;">
								<el-table-column
									prop="sales_order.sales_order_number"
									:show-overflow-tooltip="true"
									width="160"
	                                label="Sales Order No">
								</el-table-column>
								<el-table-column
									prop="sales_order.client_delivery_address.code"
									:show-overflow-tooltip="true"
									width="160"
	                                label="Delivery Code">
								</el-table-column>
								<el-table-column
									prop="quotation.item.manufacturer"
									:show-overflow-tooltip="true"
									width="250"
	                                label="Manufacturer">
								</el-table-column>
								<el-table-column
									prop="quotation.vendor.name"
									:show-overflow-tooltip="true"
									width="250"
	                                label="Vendor">
								</el-table-column>
								<el-table-column
	                                prop="quotation.item.part_number"
	                                :show-overflow-tooltip="true"
	                                label="Part Number"
	                                width="160">
	                            </el-table-column>
	                            <el-table-column
	                                prop="quantity"
	                                width="150"
	                                label="QTY">
	                            </el-table-column>
	                            <el-table-column
		                            label="ETD Vendor"
		                            :show-overflow-tooltip="true"
		                            class-name="estimated-td-vendor"
		                            width="200">
		                             <template scope="scope">
		                                <span>{{scope.row.estimated_td_vendor != null && scope.row.estimated_td_vendor != '' ? scope.row.estimated_td_vendor : 'Waiting for PO'}}</span>
		                            </template>
	                            </el-table-column>
	                            <el-table-column
		                            label="ETA HK"
		                            :show-overflow-tooltip="true"
		                            class-name="estimated-td-hk"
		                            width="200">
		                            <template scope="scope">
		                                <span v-if="!scope.row.direct_shipment">
		                                    {{scope.row.estimated_arrival_date_hk != null && scope.row.estimated_arrival_date_hk != ''? scope.row.estimated_arrival_date_hk : 'Waiting for PO'}}
		                                </span>
		                                <span v-else>
		                                	Direct Shipment
		                                </span>
		                            </template>
		                        </el-table-column>
		                        <el-table-column
                                :class-name="'col estimated-td-hk'"
                                width="200" 
                                label="Confirmed TD HK">
                                <template scope="scope">
                                  <div v-if="!scope.row.estimated_td_date">
                                    <span v-if="!scope.row.direct_shipment">Pending</span>
                                  </div>
                                  <div v-else>
                                    <span>{{scope.row.estimated_td_date}}</span>
                                  </div>
                                </template>
                              </el-table-column>
		                        <el-table-column
	                                prop="shipping_method.name"
	                                :show-overflow-tooltip="true"
	                                width="200"
	                                label="Shipping Method">
	                            </el-table-column>
	                            <el-table-column
                              :class-name="'col estimated-weight'"
                              width="200" 
                              label="Estimated weight, kg">
                              <template scope="scope">
                              	<span>{{ (scope.row.quotation.item.weight_grams > 0 ? ((scope.row.quotation.item.weight_grams * scope.row.quantity) / 1000) : ((scope.row.quotation.item.category.average_weight_grams * scope.row.quantity) / 1000)) | currency('', 2, {thousandsSeparator: ','}) }}</span>
                              </template>
                            </el-table-column>
	                            <el-table-column
	                                class-name="text-center"
	                                label="Operations"
	                                width="150">
	                                <template scope="scope">
	                                    <button @click="removeItem(scope.$index)" class="btn btn-danger btn-xtra-small">
			                                <i class="fa fa-remove"></i>
			                            </button>
	                                </template>
	                            </el-table-column>
							</el-table>
						</div>
					</div>
				</div>
			</div>

			<div class="row">
				<br>
				<div class="col-md-12 text-right">
					<button class="btn btn-primary" :disabled="!items.length" @click="status = 'contact-sharing'">Next</button>
				</div>
			</div>
		</div>

		<div class="col-md-12" v-if="status == 'contact-sharing'">
			<div class="row">
				<div class="col-md-6">
					<span><b>Step 2-4:Contact Sharing</b></span>
				</div>
			</div>

			<div class="row form-group">
				<div class="col-md-2">
					<label>Responsible person:</label>
				</div>
				<div class="col-md-4">
					<b>{{responsible_person.name}}</b>
				</div>
			</div>

			<div class="row form-group">
				<div class="col-md-2">
					<label>List of persons to share notifications:</label>
				</div>
				<div class="col-md-4">
					<multiselect placeholder="Select Person" label="name" v-model="email_person" :options="contact_options" :searchable="true" :allow-empty="true"></multiselect>
				</div>
				<div class="col-md-2">
					<button class="btn btn-primary" @click="addContact()">
						<i class="fa fa-plus"></i>
					</button>
				</div>
			</div>

			<div class="row">
				<div class="col-md-8">
					<el-table
						:data="contacts"
						border
						style="width: 100%;">
						<el-table-column
							prop="name"
							:show-overflow-tooltip="true"
                            label="Name">
						</el-table-column>
						<el-table-column
							prop="email"
							:show-overflow-tooltip="true"
                            label="E-mail">
						</el-table-column>
						<el-table-column
							width="140"
							class-name="text-center"
                            label="Operations">
                            <template scope="scope">
                            	<a class="btn btn-danger btn-xtra-small" @click="removeContact(scope.row, scope.$index)">
									<i class="fa fa-trash"></i>
								</a>
                            </template>
						</el-table-column>
					</el-table>
				</div>
			</div>

			<!-- <div class="row">
				<div class="col-md-6">
					<div class="form-group">
						<br>
						<label>Comments:</label>
						<textarea class="form-control" v-model="comments"></textarea>
					</div>
				</div>
			</div> -->

			<div class="row">
				<div class="col-md-12 text-right">
					<button class="btn btn-primary" @click="status = 'selection'">Back</button>
					<button class="btn btn-primary" @click="next">Next</button>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import Multiselect from 'vue-multiselect'
	import swal from 'sweetalert2'
	import {Pagination} from 'element-ui'
	import Modal from '../Modal.vue'
	import ContactList from '../popup-forms/contact-list.vue'
	import Datepicker from 'vuejs-datepicker'
	import {Money} from 'v-money'

	export default{
		data(){
			return {
				items:[],
				pagination:[],
				sales_order:{},
				sales_orders:[],
				sales_order_items:[],
				prev_sales_order:[],
				email_person:{},
				contacts:[],
				contact_options:[],
				sales_order_items_all: false,
				search:'',
				status:'selection',
				limit:5,
				page:1,
				show_contacts_list:false,
				comments:'',
				vendors: [],
				item_manufacturer_filters: [],
				vendor_filters: [],
				item_manufacturers: [],
				unformat_etd_date_range: '',
				responsible_person:{},
				sort_dir: null,
        		sort_by: null,
        		shipping_methods: [],
				shipping_method:[],
				delivery_codes: [],
				delivery_code: []
			}
		},
		components: {
			Money,
			'el-pagination': Pagination,
			'contact-list': ContactList,
            Multiselect,
            Modal
        },
        watch: {
        	'sales_order': function(val, prev){
        		this.getSalesOrderItems(1)
        		this.getVendors()
				this.getItemManufacturers()
        	},
        	'limit': function(){
        		this.getSalesOrderItems()
        	},
        	'status': function(val){
        		if(val == 'contact-sharing'){
        			this.getContacts()
        		}
        	},
        	unformat_etd_date_range: function () {
                this.getSalesOrderItems(1)
            },
          vendor_filters: function () {
              this.getSalesOrderItems(1)
          },
          item_manufacturer_filters: function () {
              this.getSalesOrderItems(1)
          },
          shipping_method: function () {
              this.getSalesOrderItems(1)
          },
		  delivery_code: function(){
			this.getSalesOrderItems(1)
		  }
        },
        computed: {
            selected_ids: function(){
                return this.items.map(function(a){
                    return a.id
                })
            },
            transformedManufacturerFilter: function () {
              return this.item_manufacturer_filters.map(manufacturer => {
                  return manufacturer.name
              })
          	},
          	transformedVendorFilter: function () {
              return this.vendor_filters.map(vendor => {
                  return vendor.id
              })
          	},
          	etd_date_range: data => { 
              return data.unformat_etd_date_range &&
               {
                from: data.unformat_etd_date_range[0] ? moment(data.unformat_etd_date_range[0]).format('YYYY-MM-DD') : '',
                to: data.unformat_etd_date_range[1] ? moment(data.unformat_etd_date_range[1]).format('YYYY-MM-DD') : ''
               }
          	},
          	transformedShippingMethodFilter: function () {
              return this.shipping_method.map(row => {
                  return row.id
              })
          	},
			transformedDeliveryCodeFilter: function () {
              return this.delivery_code.map(row => {
                  return row.id
              })
          	},
        },
		methods: {
			statusClass: function(row, index){
	            var class_name = ''
	            
	            if(row !== null){
	              var status = row.order_status.toLowerCase()

	              class_name += status

	              if((status == 'confirmed' && row.direct_shipment == 1) || (status == 'confirmed' && this.$root.userRole == 'purchaser')){
	                class_name += ' green-estimated-td-vendor'
	              }

	              if(status == 'confirmed' && row.direct_shipment != 1 && row.estimated_td_date && this.$root.userRole != 'purchaser'){
	                class_name += ' green-estimated-td-hk'
	              }

				  if(row.quotation.item.weight_grams > 0){
					class_name += ' has-weight-grams'
				  }else{
					class_name += ' has-no-weight-grams'
				  }
	            }

            	return class_name
          	},
			removeContact: function(row, index){
				this.contacts.splice(index, 1)
			},
			addContact: function(){

				let vm = this

				if(vm.email_person.id === undefined){
					vm.$notify({
                        title: 'Error',
                        message: 'Select person',
                        type: 'error',
                        duration: 3000
                    })

                    return false
				}

				let added = false

				$.each(this.contacts, function(key, val){
					if(vm.email_person.id == val.id){
						vm.$notify({
	                        title: 'Error',
	                        message: 'Contact already added',
	                        type: 'error',
	                        duration: 3000
	                    })

						added = true
	                    return false
					}
				})

				if(!added){
					this.contacts.push(this.email_person)
				}
			},
			getSalesOrders: function(){
				this.$http.get(process.env.API_ENDPOINT + '/sales-order-logs/completed?token=' + this.$cookies.get('teltonika_session')).then((response) => {
                  	this.sales_orders = response.body
                }, (response) => {
                  console.log(response)
                })
			},
			getSalesOrderItems: function(page = this.page){
				this.sales_order_items_all = true

				let filters = ''

				var manufacturers = this.transformedManufacturerFilter.length ? '&manufacturers=' + this.transformedManufacturerFilter.join('|') : ''
        var vendors = this.transformedVendorFilter.length ? '&vendors=' + this.transformedVendorFilter.toString() : ''
        var etd_date = this.etd_date_range ? '&etd_date_from=' + this.etd_date_range.from +  '&etd_date_to=' + this.etd_date_range.to  : ''
        var salesOrder = this.sales_order && this.sales_order.id ? '&sales_order_id=' + this.sales_order.id : ''
        var shippingMethods = this.transformedShippingMethodFilter.length ? '&shipping_method_ids=' + this.transformedShippingMethodFilter.toString() : ''
		var deliveryCodes = this.transformedDeliveryCodeFilter.length ? '&client_delivery_address_ids=' + this.transformedDeliveryCodeFilter.toString() : ''

				filters += '&limit=' + this.limit
                
        filters += '&page=' + page

        if(this.search !== ''){
            filters += '&search=' + this.search
        }

        if(this.sort_by != null){
          filters += '&sort_by=' + this.sort_by;
        }

        if(this.sort_dir != null){
          filters += '&sort_dir=' + this.sort_dir;
        }

                filters += vendors + manufacturers + etd_date + salesOrder + shippingMethods + deliveryCodes
          		//console.log(filters);
				this.$http.get(process.env.API_ENDPOINT + '/sales-order-logs/search/completed?token=' + this.$cookies.get('teltonika_session') + filters).then((response) => {
					//console.log(response)
					this.sales_order_items = response.body.data
                  	this.pagination = response.body
                  	this.sales_order_items_all = false
                }, (response) => {
                  console.log(response)
                  this.sales_order_items_all = false
                })
			},
			clearItems: function(){
				this.items = []
				this.sales_order_items=[]
			},
			addItem: function(item){
				this.items.push(item)
			},
			removeItem: function(index){
                this.items.splice(index, 1)
            },
			isAdded: function(item){
				if(this.selected_ids.includes(item.id)){
                    return true;
                }

                return false
			},
			fetchPaginate: function(page){
                if(this.page != page) {
                    this.page = page
                    this.getSalesOrderItems()
                }
            },
            handleSizeChange: function(size){
                this.limit = size
            },
            getContacts: function(){
            	this.$root.getRequest('/user/usertype?user_type=hq_top,client_p').then((response) => {
					this.contact_options = response.body.items
                }, (response) => {
                  console.log(response)
                })
            },
            contactsDisplayed: function(visible){
            	if(!visible){
            		this.getContacts()
            	}
            },
            next: function(){
            	
            	this.$http.post(process.env.API_ENDPOINT + '/som?token=' + this.$cookies.get('teltonika_session'), {
            		responsible_person_id: this.responsible_person.id,
            		items: this.items,
            		contacts: this.contacts,
            		comments: this.comments
            	}).then((response) => {

            		this.$notify({
                        title: 'Success',
                        message: 'Items added',
                        type: 'success',
                        duration: 3000
                    })

            		var route = this.$router.resolve({path: '/som/edit/'+response.body.data.id})
                    window.open(route.href, '_blank')
                    location.reload()
            	})
            },
            getVendors: function () {
            	let filters = ''

                var salesOrder = this.sales_order && this.sales_order.id ? '&sales_order_id=' + this.sales_order.id : ''
                filters += salesOrder

                this.$http.get(process.env.API_ENDPOINT + '/sales-order-logs/completed/vendors?token=' + this.$cookies.get('teltonika_session') + filters).then(response => {
                    this.vendors = response.body
                    var vendor = this.getQueryVariable('vendor');

                    if(vendor) {
                        for(var i = 0; i < this.vendors.length; i++) {
                            if(this.vendors[i]['id'] == vendor) {
                                this.vendor_filters.push(this.vendors[i]);
                                break;
                            }
                        }
                    }
                })
            },
            getItemManufacturers: function () {
            	let filters = ''

                var salesOrder = this.sales_order && this.sales_order.id ? '&sales_order_id=' + this.sales_order.id : ''
                filters += salesOrder
                this.$http.get(process.env.API_ENDPOINT + '/sales-order-logs/completed/manufacturers?token=' + this.$cookies.get('teltonika_session') + filters).then(response => {
                    this.item_manufacturers = response.body
                })
            },
            getQueryVariable(variable){
                var url = decodeURIComponent(window.location.href),
                url = url.split('?'),
                query = '';
                if(url.length > 1) {
                    query = url[1];
                }
                var vars = query.split("&");
                for (var i=0;i<vars.length;i++) {
                   var pair = vars[i].split("=");
                   if(pair[0] == variable){return pair[1];}
                }
                return(false);
            },
          sortTable: function(data) {
            // console.log(data)
            this.sort_by = data.prop
            this.sort_dir = data.order;
            if(data.order != null) {
              this.sort_dir = data.order == 'ascending' ? 'asc' : 'desc'
            }

            this.getSalesOrderItems(1)
            // console.log(this.sort_by)
            // console.log(this.sort_dir)
          },
          getShippingMethods: function () {
              this.$http.get(process.env.API_ENDPOINT + '/shipping-method?token=' + this.$cookies.get('teltonika_session')).then((response) => {
                  if (response.status == 200) {
                      this.shipping_methods = response.data
                  }
              }, (response) => {
                  // fail
              })
          },
		  getDeliveryCodes: function () {
              this.$http.get(process.env.API_ENDPOINT + '/salesorder/delivery-codes?token=' + this.$cookies.get('teltonika_session')).then((response) => {
                  if (response.status == 200) {
                      this.delivery_codes = response.data
                  }
              }, (response) => {
                  // fail
              })
          },
		},
		created(){
			this.responsible_person = this.$root.user
			this.getSalesOrders()
			this.getVendors()
      		this.getItemManufacturers()
      		this.getShippingMethods()
			this.getDeliveryCodes()
		}
	}
</script>

<style>
    .hq-delivery-date-change .modal-dialog {
        max-width: 95%;
        margin: 30px auto; 
    }

    .modal-mask{
        z-index:1000 !important;
    }
    .el-pagination__total {
        font-size: 14px;
        font-weight: 800;
    }
</style>


// WEBPACK FOOTER //
// hq-delivery-date-change.vue?39bbfec1